import useOnClickOutside from '@/hooks/useOnClickOutside';
import { useRef, useState } from 'react';
import { FUND_EXPIRATION_LIST } from './config';
import { twMerge } from 'tailwind-merge';
import {
  DEFAULT_TOKEN_IDO_CURVE,
  DEFAULT_TOKEN_IDO_CURVE_MAX,
  DEFAULT_TOKEN_IDO_CURVE_MIN,
} from '@/config';
import InputRange from '../inputRange';
import NumberFormat from 'react-number-format';

const FormDeFaiAgentInfo = ({
  fundExp,
  setFundExp,
  curve,
  setCurve,
  party,
  setParty,
  coinInfo,
}) => {
  const refFundExpiration = useRef();
  const [selectFundExp, setSelectFundExp] = useState(false);

  useOnClickOutside(refFundExpiration, () => {
    setSelectFundExp(false);
  });

  return (
    <div className="flex flex-col gap-6">
      {coinInfo && (
        <div>
          <div className="text-[14px] text-[#9192A0] rounded-lg">
            The IDO (Initial DEX Offering) is a modern fundraising method that
            allows projects to sell their tokens directly to participants with
            ease and transparency.
          </div>
        </div>
      )}
      <div>
        <label className="cursor-pointer text-[12px] uppercase font-medium text-[#84869A] flex items-center">
          Fund expiration&nbsp;
          <span className="text-red-700">*</span>
        </label>

        <div
          ref={refFundExpiration}
          className="relative cursor-pointer mt-3"
          onClick={() => {
            setSelectFundExp(!selectFundExp);
          }}
        >
          <div className="flex items-center justify-between w-full px-3 border border-[#585A6B] rounded h-12">
            <div className="flex items-center">{fundExp?.label}</div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2071 8.24992C18.8166 7.8594 18.1834 7.8594 17.7929 8.24992L12 14.0428L6.20711 8.24992C5.81658 7.8594 5.18342 7.8594 4.79289 8.24992C4.40237 8.64044 4.40237 9.27361 4.79289 9.66413L10.5858 15.457C11.3668 16.2381 12.6332 16.2381 13.4142 15.457L19.2071 9.66414C19.5976 9.27361 19.5976 8.64045 19.2071 8.24992Z"
                fill="#9192A0"
              />
            </svg>
          </div>
          {selectFundExp && (
            <div className="pt-2 absolute top-full w-full z-10">
              <div className="bg-[#1A1C28] shadow shadow-[rgba(0,_0,_0,_0.10)] p-3 text-[12px] text-[#F7F7F7] rounded-lg flex flex-col gap-2 overflow-y-auto max-h-52 h-100%">
                {FUND_EXPIRATION_LIST.map((e, ind) => {
                  return (
                    <button
                      className={twMerge(
                        'flex items-center justify-between rounded-lg hover:bg-[#13141D] p-3 disabled:cursor-not-allowed',
                        fundExp?.value === e.value &&
                          'bg-[#13141D] cursor-not-allowed',
                      )}
                      key={`fund-exp-item-${ind}`}
                      onClick={() => setFundExp(e)}
                    >
                      {e.label}
                    </button>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </div>
      <div>
        <label className="cursor-pointer text-[12px] uppercase font-medium text-[#84869A] flex items-center">
          Bonding size&nbsp; ({DEFAULT_TOKEN_IDO_CURVE_MIN} SOL -{' '}
          {DEFAULT_TOKEN_IDO_CURVE_MAX} SOL)&nbsp;
          <span className="text-red-700">*</span>{' '}
        </label>
        <div className="mt-5 flex gap-4">
          <div className="w-full mx-7">
            <InputRange
              max={5000}
              min={500}
              value={curve}
              onChange={(floatValue) => setCurve(floatValue)}
            />
          </div>
          <NumberFormat
            placeholder={`Bonding size`}
            thousandSeparator
            className={`w-40 hidden md:block outline-none focus:outline-none px-3 border border-[#585A6B] mt-3 rounded h-12 text-[#E8E9EE] bg-transparent`}
            decimalScale={0}
            allowNegative={false}
            type="text"
            suffix=" SOL"
            value={curve}
            onChange={() => {}}
            isAllowed={(values) => {
              const { floatValue } = values;
              // allow !floatValue to let user can clear their input
              return (
                !floatValue ||
                (floatValue >= 0 && floatValue <= DEFAULT_TOKEN_IDO_CURVE_MAX)
              );
            }}
            onValueChange={({ floatValue }) => {
              if (
                floatValue < DEFAULT_TOKEN_IDO_CURVE_MIN ||
                floatValue > DEFAULT_TOKEN_IDO_CURVE_MAX
              ) {
                return;
              }
              setCurve(floatValue);
            }}
          />
        </div>
      </div>
      <div>
        <label className="cursor-pointer text-[12px] uppercase font-medium text-[#84869A] flex items-center">
          Party Round&nbsp; (1h - 24h)&nbsp;
          <span className="text-red-700">*</span>{' '}
        </label>
        <div>
          <NumberFormat
            placeholder={`Party Round`}
            thousandSeparator
            className="outline-none focus:outline-none w-full px-3 border border-[#585A6B] mt-3 rounded h-12 text-[#E8E9EE] bg-transparent"
            decimalScale={1}
            type="text"
            suffix=" Hour(s)"
            value={party}
            onChange={() => {}}
            isAllowed={(values) => {
              const { floatValue } = values;
              const minVal =
                import.meta.env.VITE_APP_SOLANA_ENV === 'mainnet-beta' ? 1 : 0;
              // allow !floatValue to let user can clear their input
              return (
                !floatValue || (floatValue >= (minVal || 0) && floatValue <= 24)
              );
            }}
            onValueChange={({ floatValue }) => {
              setParty(floatValue);
            }}
          />
        </div>
      </div>
      {coinInfo && (
        <div className="border rounded-sm border-[#30344A] p-2 md:p-6 mt-6">
          {coinInfo.ticker && (
            <>
              <div>
                <div>Tokenomics</div>
                <div className="mt-4">
                  We raise {curve} SOL for&nbsp;
                  {DEFAULT_TOKEN_IDO_CURVE}M $
                  <span className="uppercase">{coinInfo.ticker || ''}</span>
                </div>
              </div>
              <div className="w-full border-b border-[#30344A] my-3 md:my-6"></div>
            </>
          )}
          <div>
            <div>With some distribution at TGE</div>
            <div className="flex flex-col gap-4 mt-3">
              <div className="flex w-full justify-between items-center text-[#E8E9EE]">
                <span className="text-[#9192A0]">Agent itself</span>
                <span>10M</span>
              </div>
              <div className="flex w-full justify-between items-center text-[#E8E9EE]">
                <span className="text-[#9192A0]">Distilled AI</span>
                <span>10M</span>
              </div>
              <div className="flex w-full justify-between items-center text-[#E8E9EE]">
                <span className="text-[#9192A0]">Strongbox</span>
                <span>20M</span>
              </div>
              <div className="flex w-full justify-between items-center text-[#E8E9EE]">
                <span className="text-[#9192A0]">Creator</span>
                <span className="text-right">
                  10M at TGE with 40M on vesting milestones
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FormDeFaiAgentInfo;
